import { ViewType } from "@common/types/views/views";
import {
    balanceSheetCloseTemplateViewConfigSchema,
    profitLossCloseTemplateViewConfigSchema,
} from "@common/schemas/close-template-task-view-config.schema";

export interface CreateReportViewConfigParams {
    numberOfMonthsToShowBeforeCurrentClosePeriods?: number | null;
}

export function createProfitLossViewConfig({
    numberOfMonthsToShowBeforeCurrentClosePeriods = null,
}: CreateReportViewConfigParams = {}) {
    return profitLossCloseTemplateViewConfigSchema.parse({
        type: ViewType.PROFIT_LOSS,
        columns: [],
        filters: {},
        ...(numberOfMonthsToShowBeforeCurrentClosePeriods != null
            ? { numberOfMonthsToShowBeforeCurrentClosePeriods }
            : {}),
    });
}

export function createBalanceSheetViewConfig({
    numberOfMonthsToShowBeforeCurrentClosePeriods = null,
}: CreateReportViewConfigParams = {}) {
    return balanceSheetCloseTemplateViewConfigSchema.parse({
        type: ViewType.BALANCE_SHEET,
        columns: [],
        filters: {},
        ...(numberOfMonthsToShowBeforeCurrentClosePeriods != null
            ? { numberOfMonthsToShowBeforeCurrentClosePeriods }
            : {}),
    });
}
